import { t } from '@/i18n';
import { passwordType } from '@/utils';
import { z } from 'zod';

export const InitializePasswordFormSchema = z
  .object({
    newPassword: passwordType,
    confirmPassword: passwordType,
  })
  .refine((values) => values.newPassword === values.confirmPassword, {
    path: ['confirmPassword'],
    message: t('validation.password-must-match'),
  });

export const InitializePasswordSchema = z.object({
  token: z.string(),
  newPassword: z.string(),
});
